import accessibleSelect from '../native-accessible-select/native-accessible-select';
export default class RefreshSelects {
    constructor($element) {
		'ngInject';
		this.rootElementForSelects = $element[0];
	}
    rerenderNativeSelects() {
		setTimeout(() => {
			let designSelects = Array.from(this.rootElementForSelects.querySelectorAll('.accessible-select-wrapper'));
			designSelects.forEach(item => {
				item.parentNode.removeChild(item);
			});

			let selects = Array.from(this.rootElementForSelects.querySelectorAll('select'));
			selects.forEach(item => {
				item.removeAttribute('has-accessible-select');
				setTimeout(() => {
					new accessibleSelect({ element: item });
				}, 0);
			});
		}, 0);
	}
}


// WEBPACK FOOTER //
// ../source/common/utils/refresh-selects.js